import { render, staticRenderFns } from "./VCode.vue?vue&type=template&id=2531264a&scoped=true&"
import script from "./VCode.vue?vue&type=script&lang=js&"
export * from "./VCode.vue?vue&type=script&lang=js&"
import style0 from "./VCode.vue?vue&type=style&index=0&id=2531264a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531264a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
